import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: '100%',
            backgroundColor: 'background.base.default',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            alignSelf: 'stretch',
            position: 'absolute',
            zIndex: 1,
            borderBottom: '1px solid',
            borderBottomColor: 'border.neutral.default',
        },
        content: {
            layerStyle: 'page',
            display: 'flex',
            paddingY: {base: 'xsmall.xl', lg: 'xxsmall-1.xl'},
            paddingX: {base: 'xsmall.xl', lg: 'medium.xl'},
            justifyContent: 'space-between',
            alignItems: ['flex-end', 'flex-end', 'flex-end', 'center'],
            flexShrink: 0,
            gap: {base: 'xsmall.xl', lg: 'xxsmall-1.xl'},
            flexDirection: ['column', 'column', 'column', 'row'],
            width: '100%',
        },
        closeIconContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: remCalc(36),
            height: remCalc(36),
        },
        closeIcon: {
            width: remCalc(16),
            height: remCalc(16),
            minWidth: '0',
            minHeight: '0',
            color: 'foreground.neutral.default',
        },
        ctaContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: {base: 'center', lg: 'flex-end'},
            alignItems: 'center',
            gap: 'xxsmall-1.xl',
            width: '100%',
        },
        labelContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignSelf: 'stretch',
            alignItems: 'center',
            gap: remCalc(16),
        },
        label: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
            width: '100%',
            alignSelf: 'stretch',
            alignItems: 'center',
        },
        blueButton: {
            width: '100%',
            maxWidth: '100px',
            minWidth: 0,
            variant: 'primary',
        },
        // whiteButton: {
        //     width: ['100%', '100%', '100%', remCalc(246)],
        //     variant: 'outline',
        // },
        blueButtonText: {
            flex: '1 0 0',
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            textAlign: 'center',
            textStyle: 'body-medium',
        },
        whiteButtonText: {
            flex: '1 0 0',
            textAlign: 'center',
            textStyle: 'body-medium',
        },
        hideOnMobile: {
            display: {base: 'none', lg: 'flex'},
        },
        hideOnDesktop: {
            display: {base: 'flex', lg: 'none'},
        },
        inputContainer: {
            maxWidth: {base: '100%', lg: remCalc(200)},
            width: '100%',
        },
    },
}
